module.exports = __webpack_public_path__ + "img/home.8cad058d.png";